var _dec, _dec2, _dec3, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import injectStyles from '4finance-components';
import translate from '4finance-translate';
import { connectState, connectActions } from '../../redux/connect';
import RecoverStep from '../../enums/recoverStep';
import CheckRecoverData from '../CheckRecoverData';
import EmailSent from '../EmailSent';
import EnterNewPassword from '../EnterNewPassword';
import Loader from '../Loader';
import RecoverBy from '../RecoverBy';
import RecoverChoice from '../RecoverChoice';
import ResetRecoverType from '../ResetRecoverType';
import UserLockdown from '../UserLockdown';
import UserError from '../UserError';
import NewPasswordSaved from '../NewPasswordSaved';
import RecoverType from '../../enums/recoverType';
import styles from './PasswordRecovery.jss';
var PasswordRecovery = (_dec = connectState({
  state: ['passwordRecover']
}), _dec2 = connectActions({
  actions: ['passwordActions']
}), _dec3 = injectStyles(styles), _dec(_class = _dec2(_class = translate(_class = _dec3(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PasswordRecovery, _React$PureComponent);
  function PasswordRecovery() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, PasswordRecovery);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PasswordRecovery)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSuccessRecoverBtnClick", function () {
      var _this$props = _this.props,
        state = _this$props.state,
        onSuccessRecoverButtonClick = _this$props.onSuccessRecoverButtonClick;
      onSuccessRecoverButtonClick({
        recoverType: state.get('recoverType')
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSignInClickHandler", function (e) {
      var onBackToSignInClick = _this.props.onBackToSignInClick;
      e.preventDefault();
      onBackToSignInClick();
    });
    return _this;
  }
  _createClass(PasswordRecovery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        state = _this$props2.state,
        actions = _this$props2.actions,
        mobilePhoneRecoveryOnly = _this$props2.mobilePhoneRecoveryOnly;
      if (state.get('recoverToken') !== '' && state.get('recoverCode') !== '' && !state.get('isLoading')) {
        actions.checkRecoveryCodeValidityFetch(state.get('recoverCode'));
      }
      if (mobilePhoneRecoveryOnly) {
        actions.setPhoneRecover();
      }
    }
  }, {
    key: "renderRecoverBy",
    value: function renderRecoverBy() {
      var _this$props3 = this.props,
        actions = _this$props3.actions,
        initiateWithCaptcha = _this$props3.initiateWithCaptcha,
        state = _this$props3.state,
        onContactSupportClick = _this$props3.onContactSupportClick,
        isCaptchaInvisible = _this$props3.isCaptchaInvisible,
        mobilePhoneRecoveryOnly = _this$props3.mobilePhoneRecoveryOnly;
      return React.createElement(RecoverBy, {
        recoverType: state.get('recoverType'),
        checkRecoveryEmailValidity: actions.recoverByEmailFetch,
        checkRecoveryCodeValidity: actions.recoverByPhoneFetch,
        attemptCount: state.get('attemptCount'),
        phoneNumberFormat: state.get('phoneNumberFormat'),
        captchaApiKey: state.get('captchaApiKey'),
        captchaLanguage: state.get('captchaLanguage'),
        initiateWithCaptcha: initiateWithCaptcha,
        isCaptchaInvisible: isCaptchaInvisible,
        mobilePhoneRecoveryOnly: mobilePhoneRecoveryOnly
      }, !mobilePhoneRecoveryOnly && React.createElement(ResetRecoverType, {
        onContactSupportClick: onContactSupportClick
      }));
    }
  }, {
    key: "renderCheckRecoverData",
    value: function renderCheckRecoverData() {
      var _this$props4 = this.props,
        onContactSupportClick = _this$props4.onContactSupportClick,
        actions = _this$props4.actions,
        state = _this$props4.state,
        mobilePhoneRecoveryOnly = _this$props4.mobilePhoneRecoveryOnly;
      return React.createElement(CheckRecoverData, {
        recipient: state.get('recipient'),
        checkRecoveryCodeValidity: actions.checkRecoveryCodeValidityFetch
      }, !mobilePhoneRecoveryOnly && React.createElement(ResetRecoverType, {
        onContactSupportClick: onContactSupportClick
      }));
    }
  }, {
    key: "renderEmailSentInfo",
    value: function renderEmailSentInfo() {
      var _this$props5 = this.props,
        onContactSupportClick = _this$props5.onContactSupportClick,
        actions = _this$props5.actions,
        state = _this$props5.state;
      return React.createElement(EmailSent, {
        onTryAgainClick: actions.setEmailRecover,
        recipient: state.get('recipient')
      }, React.createElement(ResetRecoverType, {
        onContactSupportClick: onContactSupportClick
      }));
    }
  }, {
    key: "renderUserError",
    value: function renderUserError() {
      var _this$props6 = this.props,
        onContactSupportClick = _this$props6.onContactSupportClick,
        actions = _this$props6.actions,
        state = _this$props6.state,
        mobilePhoneRecoveryOnly = _this$props6.mobilePhoneRecoveryOnly;
      return React.createElement(UserError, {
        errorCode: state.get('errorCode'),
        tryAgainOrOther: true,
        onTryAgainClick: actions.resetRecoverType,
        onContactSupportClick: onContactSupportClick,
        mobilePhoneRecoveryOnly: mobilePhoneRecoveryOnly
      });
    }
  }, {
    key: "renderNewPasswordSaved",
    value: function renderNewPasswordSaved() {
      var _this$props7 = this.props,
        onSuccessRecover = _this$props7.onSuccessRecover,
        state = _this$props7.state;
      onSuccessRecover({
        recoverType: state.get('recoverType')
      });
      return React.createElement(NewPasswordSaved, {
        onSuccessButtonClick: this.onSuccessRecoverBtnClick
      });
    }
  }, {
    key: "renderRecoverStep",
    value: function renderRecoverStep() {
      var _this$props8 = this.props,
        state = _this$props8.state,
        actions = _this$props8.actions,
        hideUserError = _this$props8.hideUserError,
        hideLockdownChatIcon = _this$props8.hideLockdownChatIcon,
        strongPassword = _this$props8.strongPassword,
        customPasswordValidation = _this$props8.customPasswordValidation;
      var isPhoneRecover = state.get('recoverType') === RecoverType.PHONE_RECOVER;
      if (state.get('isLoading')) {
        return React.createElement(Loader, null);
      }
      switch (state.get('recoverStep')) {
        case RecoverStep.RECOVER_CHOICE:
          return React.createElement(RecoverChoice, {
            setPhoneRecover: actions.setPhoneRecover,
            setEmailRecover: actions.setEmailRecover
          });
        case RecoverStep.ENTER_DATA_FOR_RECOVER:
          return this.renderRecoverBy();
        case RecoverStep.EMAIL_SENT_INFO:
          return this.renderEmailSentInfo();
        case RecoverStep.CHECK_ENTERED_RECOVER_DATA:
          return this.renderCheckRecoverData();
        case RecoverStep.ENTER_NEW_PASSWORD:
          return React.createElement(EnterNewPassword, {
            saveNewPassword: actions.savePasswordFetch,
            strongPassword: strongPassword,
            customPasswordValidation: customPasswordValidation
          });
        case RecoverStep.USER_ERROR:
          {
            if (hideUserError) {
              return isPhoneRecover ? this.renderCheckRecoverData() : this.renderEmailSentInfo();
            }
            return this.renderUserError();
          }
        case RecoverStep.USER_LOCKDOWN:
          return React.createElement(UserLockdown, {
            hideChatIcon: hideLockdownChatIcon
          });
        case RecoverStep.NEW_PASSWORD_SAVED:
          return this.renderNewPasswordSaved();
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
        classes = _this$props9.classes,
        msg = _this$props9.msg;
      return React.createElement("div", {
        className: classes.component
      }, React.createElement("div", {
        className: classes.main
      }, React.createElement("div", {
        className: classes.container
      }, this.renderRecoverStep())), React.createElement("div", {
        className: classes.backLink
      }, React.createElement("a", {
        href: "#",
        onClick: this.onSignInClickHandler
      }, msg('common.backToSignInLinkText'))));
    }
  }]);
  return PasswordRecovery;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'PasswordRecovery'), _temp)) || _class) || _class) || _class) || _class);
export { PasswordRecovery as default };